import React from 'react';
import PropTypes from 'prop-types';
import loadjs from 'loadjs';
import { withRouter } from 'react-router';

import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';
import { Title } from '@nerdwallet/currency';

import { getJobRelativePath } from '~/client/lib/department-utils';
import CompanyJob from './company-job/company-job';
import CompanyApplyJob from './company-apply-job/company-apply-job';
import styles from './job-page.module.less';

const JobPage = ({ job, location }) => {
  const [showUntrackedApp, setShowUntrackedApp] = React.useState(false);
  const [showTrackedApp, setShowTrackedApp] = React.useState(false);

  const greenhouseRef = React.useRef(null);

  React.useEffect(() => {
    const queryString = location.search;
    if (queryString?.includes('gh_src=')) {
      setShowTrackedApp(true);
    } else {
      setShowUntrackedApp(true);
    }
  }, [location]);

  React.useEffect(() => {
    if (showTrackedApp) {
      loadjs(
        'https://boards.greenhouse.io/embed/job_board/js?for=nerdwallet',
        () => {}
      );
    }
  }, [showTrackedApp]);

  return (
    <div ref={greenhouseRef} className={styles.grnhseAppCont}>
      <GlobalMarkupOptions>
        {{
          theme: 'company',
          ogTags: {
            url: getJobRelativePath(job),
            title: job.title,
          },
        }}
      </GlobalMarkupOptions>
      <CompanyJob job={job} />
      <div id="applyJob">
        <Title size="small" className={styles.jobTitle} component="h2">
          Apply for this role
        </Title>
        {showUntrackedApp && <CompanyApplyJob id={job.id} />}
      </div>
      {showTrackedApp && (
        <div id="grnhse_app" className={styles.greenhouseApp} />
      )}
    </div>
  );
};

JobPage.displayName = 'Job Page';

JobPage.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
  }).isRequired,
  location: PropTypes.object,
};

export default withRouter(JobPage);
